// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const NotificationConstants = Marty.createConstants([
  'NOTIFICATION_DISPLAY_DONE',
  'NOTIFICATION_PUSH',
  'CLEAR_NOTIFICATIONS'
])

export default NotificationConstants

export const WEB_PUSH_SERVER_PUBLIC_KEY = 'BNcmBXOKZwIABd72e1H_DG1tyKMf6P4wKH7q8qkjMpHe6JIODFIn0mPOeT9Tq94WiABYq2818rFGKiiWExKJtWA=';



// WEBPACK FOOTER //
// ./src/scripts/constants/NotificationConstants.js